import React from "react";
import { TECH_STACK } from "../../mock";

export default function TechStack() {
  return (
    <section className="py-20 lg:py-24 bg-white border-b border-slate-100">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
          <div>
            <span className="section-eyebrow">Tech stack</span>
            <h2 className="mt-4 text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-slate-900">
              Modern tools, chosen for the job — not the hype.
            </h2>
          </div>
          <p className="text-slate-600 max-w-sm text-sm">
            We pick the right stack for each project. Here are some of the tools we love and use daily.
          </p>
        </div>

        <div className="flex flex-wrap gap-2.5">
          {TECH_STACK.map((t) => (
            <span
              key={t}
              className="px-4 py-2 rounded-full border border-slate-200 bg-slate-50 hover:bg-white hover:border-slate-900 hover:text-slate-900 transition-colors text-sm text-slate-700 cursor-default"
            >
              {t}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
